export default function PersonForm({ person, profileStatus, profileError, onReload, onEditProfile }) {
  const inp = (label, key, type = "text") => (
    <div className="field">
      <label className="field-label">
        {label}<span className="badge-db">PROFILE</span>
      </label>
      <input className="field-input readonly" type={type} value={person[key] || ""} readOnly />
    </div>
  );

  return (
    <div className="card">
      <h2 className="section-title">従事者情報</h2>
      <p className="help-text">
        profile.nkmr.io に登録された、ログイン中の本人情報を表示しています。
        このシステムのDBやブラウザには保存しません。
      </p>

      <div className="db-select-row">
        <div>
          <span className="field-label">従事者ID</span>
          <strong>{person.id || (profileStatus === "loading" ? "読込中…" : "未取得")}</strong>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button className="btn" type="button" onClick={onReload} disabled={profileStatus === "loading"}>
            {profileStatus === "loading" ? "読込中…" : "プロフィールを再読込"}
          </button>
          <button className="btn btn-primary" type="button" onClick={onEditProfile}>
            profile.nkmr.ioで登録・編集
          </button>
        </div>
      </div>

      {profileError && <div className="info-box" style={{ marginTop: 12 }}>{profileError}</div>}

      <h3 className="subsection-title">基本情報</h3>
      <div className="form-grid">
        {inp("フリガナ", "furigana")}
        {inp("氏名", "name")}
        {inp("生年月日", "dob", "date")}
        <div className="field field-wide">{inp("勤務先・職名・学部・学年", "school")}</div>
        {inp("電話番号", "phone", "tel")}
        {inp("郵便番号", "zip")}
        <div className="field field-wide">{inp("住所", "address")}</div>
      </div>

      <h3 className="subsection-title">口座情報</h3>
      <div className="form-grid">
        {inp("銀行名", "bankName")}
        {inp("支店名", "branchName")}
        {inp("支店番号", "branchNo")}
        {inp("口座種別", "accountType")}
        {inp("口座番号", "accountNo")}
        <div className="field field-wide">{inp("口座名義（カナ）", "accountName")}</div>
      </div>
    </div>
  );
}
